/**
 * Confirms the current login with importscan-rewrite-api: the first
 * authenticated request carrying the token's loginLogId marks the login row
 * confirmed, giving it session authority. Lighthouse calls no other
 * session-checked rewrite-api endpoint, so without this ping a login used
 * only here would stay unconfirmed. Fire-and-forget — the response is
 * intentionally ignored.
 */
export default function confirmLogin({ $axios, $auth }) {
  if (!$auth || !$auth.loggedIn || !process.env.IMPORTSCAN_AWS_URL) {
    return
  }

  $axios
    .post(
      `${process.env.IMPORTSCAN_AWS_URL}/check/page-view`,
      {},
      { progress: false }
    )
    .catch(() => {})
}
